/**
 * PartyMergeBox — fusionner la fiche ouverte dans une autre fiche (conservée) : ses pièces, notes et paiements y passent, la fiche est supprimée.
 */
import { useState } from "react";
import { GitMerge } from "lucide-react";
import { api } from "@/api";
import { toast } from "@/lib/toast";
import { Btn, errMsg, useGlBase } from "../comptabilite/_shared";
import { PARTY_CFG, PartySelect, useParties } from "./_books";

export default function PartyMergeBox({ kind, party, onMerged, onCancel }) {
  const base = useGlBase();
  const cfg = PARTY_CFG[kind];
  const { parties } = useParties(kind);
  const [target, setTarget] = useState("");
  const [busy, setBusy] = useState(false);
  const t = parties.find((p) => p.id === target);

  const merge = async () => {
    if (!t) return;
    if (!window.confirm(`Fusionner « ${party.name} » dans « ${t.name} » ?\nToutes ses pièces, notes et paiements passeront à « ${t.name} » et la fiche « ${party.name} » sera supprimée.`)) return;
    setBusy(true);
    try { await api.post(`${base}/${cfg.path}/${party.id}/merge`, { target_id: target }); toast.success(`Fusionné dans ${t.name}`); onMerged(); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="border border-violet-200 bg-violet-50 rounded-xl p-3 space-y-2" data-testid="party-merge-box">
      <div className="text-xs text-violet-900"><strong>Fusionner cette fiche</strong> dans une autre : ses {cfg.docKind === "sale" ? "ventes" : "achats"}, notes et paiements passeront à la fiche choisie ; « {party.name} » sera supprimée.</div>
      <div className="flex gap-2 items-center flex-wrap">
        <div className="flex-1 min-w-[220px]"><PartySelect kind={kind} parties={parties.filter((p) => p.id !== party.id)} value={target} onChange={setTarget} allLabel="— Fiche à conserver —" testId="party-merge-target" /></div>
        <Btn tone="slate" onClick={onCancel} testId="party-merge-cancel">Annuler</Btn>
        <Btn icon={GitMerge} onClick={merge} busy={busy} disabled={!target} testId="party-merge-confirm">Fusionner</Btn>
      </div>
    </div>
  );
}
